import { useSelector } from "react-redux";

// 0015: pure reader. The fetch of website configurations now happens once in <AppBootstrap/>
// (React Query, deduped) and is bridged into Redux. This hook only reads the Logo config from the
// store. isLoading reflects whether configurations have loaded yet (NOT whether a Logo exists), so
// the header logo placeholder resolves even when no Logo is configured.
const useLogoConfiguration = () => {
  const configurations = useSelector((state) => state.websiteConfigurationReducer.configurations);
  const logoConfiguration = configurations.find((config) => config.key === "Logo");

  const logoUrl = logoConfiguration?.value ? JSON.parse(logoConfiguration.value)?.Url : null;
  const isLoading = configurations.length === 0;

  return { logoUrl, isLoading };
};

export default useLogoConfiguration;
